import Vue from 'vue';
import {Drawer, Button} from "ant-design-vue";

Vue.use(Drawer);
Vue.use(Button);


